/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { Component, Input } from '@angular/core';
import { LabelWithCurrencyInnerHtmlComponent } from './label-with-currency-inner-html.component';

@Component({
    selector: 'input-with-currency-prefix',
    templateUrl: './label-with-currency-inner-html.component.html',
    standalone: false
})

/// This component is designed to be used in where a form input is using the InnerHTML property with a currency symbol prefix
/// matTextPrefix should be applied to the calling HTML element
export class InputWithCurrencyPrefixComponent extends LabelWithCurrencyInnerHtmlComponent {
    // Add any additional properties or methods specific to this component
    // An optional input for you to include if the currency symbol should be in brackets, this is false by default overriding the base implementation.
    @Input() includeBrackets: boolean = false;

    // Override the textDisplay method from the base class
    textDisplay() {
        return this.currencySymbol() + ' &nbsp;';
    }
}